<div class="w-100 top__bar d-lg-none d-flex" *ngIf="shwoTopbar">
    <div class="top__bar_left">
        <h6>For the best experience</h6>
        <p>We recommend using our app or switching to a laptop/desktop.</p>
    </div>
    <div class="top__bar_right">
        <svg class="close--btn" (click)="hideTopBarFun()" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 35C27.35 35 35 27.35 35 18C35 8.65 27.35 1 18 1C8.65 1 1 8.65 1 18C1 27.35 8.65 35 18 35Z"
                stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.4609 21.5374L21.5359 14.4624" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            <path d="M21.5359 21.5374L14.4609 14.4624" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>

        <button class="btn btn-border" (click)="redirectToApp()">Download Now</button>
    </div>
</div>
<router-outlet></router-outlet>
<!-- Intercom -->
<div class="bottom-bar" [ngClass]="{'finance-customer-style': mainService.currentUrl === '/app/finance-customer'}"  [ngStyle]="{'justify-content': mainService.currentUrl === '/app/finance-customer' ? 'space-between' : 'flex-end',
    'margin-left': mainService.currentUrl === '/app/finance-customer' ? '260px' : ''}" *ngIf="authService.showIntercomIcon">
  <div class="training-banner ms-2" *ngIf="mainService.currentUrl == '/app/finance-customer'"  (click)="openModal();" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()">
    <div style="display: flex; align-items: center;">
      <span
        style="background: #39CB7A; width: 38px; height: 38px; display: flex; justify-content: center; align-items: center; border-radius: 50%;">
        <img alt="Calendar Icon" src="assets/img/svg/calendar-time.svg" />
      </span>

      <div class="content ps-2">
        <p class="p-0 m-0 f-Inter" style="font-weight: 500; font-size: 12px;">Not Sure Where to Start?</p>
        <p class="p-0 m-0 f-Inter" style="font-weight: 500; font-size: 12px;">
          Book a <b style="font-weight: 700; ">Free Training</b> and see how Denefits can work for you!
        </p>
      </div>
    </div>
    <div class="training-button-container ps-3">
      <button class="f-Inter">{{ buttonText }}</button>
      <img class="ps-2" src="assets/img/svg/box-arrow.svg">
    </div>
  </div>
  <img id="open_chat" src="assets/img/svg/chat_icon.svg" alt="" class="intercom-icon">
</div>
<div data-html2canvas-ignore class="gtranslate_wrapper"></div>
<div *ngIf="!envProd && !envDemo" #envDropdownTarget>
  <div (click)="envDropdown = !envDropdown" class="testEnv">{{currentEnv.name}} <i [ngClass]="envDropdown ? 'fa fa-angle-down' : 'fa fa-angle-up'" aria-hidden="true"></i></div>
  <div class="testDropdown" [class.env-show]="envDropdown">
    <div class="env-item" *ngFor="let env of envs" (click)="changeEnv(env.id)">{{env.name}}</div>
  </div>
</div>
<app-loader data-html2canvas-ignore *ngIf="isShowingRouteLoadIndicator || show"></app-loader>
<!-- Global "Prepaid Cards Not Accepted" pop-up, opened via PrepaidCardService.check() -->
<app-prepaid-card-modal></app-prepaid-card-modal>
